export default "__VITE_ASSET__DL9C4F_Q__"